import { forwardRef, useState, useRef } from 'react';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { FieldTextarea } from '../Field/FieldTextarea/FieldTextarea.js';
import { FieldContainer } from '../Field/FieldContainer/FieldContainer.js';
import { FieldContent } from '../Field/FieldContent/FieldContent.js';
import { FieldLabel } from '../Field/FieldLabel/FieldLabel.js';

const Textarea = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    className,
    disabled = false,
    label,
    name,
    isInvalid = false,
    readOnly = false,
    showLabel = true,
    value = '',
    onBlur,
    onChange,
    onFocus,
    ...rest
  } = props;
  const [isFocused, setIsFocused] = useState(false);
  const onBlurTextarea = event => {
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    setIsFocused(false);
  };
  const onFocusTextarea = event => {
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
    setIsFocused(true);
  };
  const textareaRef = useRef(null);
  const onChangeTextarea = event => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${event.target.scrollHeight}px`;
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
  };
  return jsx(FieldContainer, {
    className: className,
    isFocused: isFocused,
    isInvalid: isInvalid,
    disabled: disabled,
    readOnly: readOnly,
    ref: ref,
    children: jsxs(FieldContent, {
      children: [showLabel && label && jsx(FieldLabel, {
        htmlFor: name,
        hasFocusedValue: isFocused || value !== '',
        children: label
      }), jsx(FieldTextarea, {
        disabled: disabled,
        isInvalid: isInvalid,
        name: name,
        readOnly: readOnly,
        ref: textareaRef,
        showLabel: showLabel,
        value: value,
        onBlur: onBlurTextarea,
        onChange: onChangeTextarea,
        onFocus: onFocusTextarea,
        ...rest
      })]
    })
  });
});
Textarea.displayName = 'Textarea';

export { Textarea };
//# sourceMappingURL=Textarea.js.map
